import React from 'react';
import { Card, Button } from '@cimpress/react-components';

const CardDemo = () => (
  <div className="card-deck">
    <Card header="Card with Text Header">
      <p className="card-text">This is a regular card.</p>
      <p className="card-text">It is fairly pedestrian.</p>
      <p className="card-text">You can use it to organize content.</p>
    </Card>
    <Card header="Minimal!" isMinimal={true}>
      <p className="card-text">A card with a more minimal header style and a button.</p>
      <p className="card-text">It looks so shiny.</p>
      <Button variant="primary">Primary CTA</Button>
    </Card>
    <Card variant="layout" header="White Layout Card">
      <p className="card-text">This is a layout card.</p>
      <p className="card-text">It has no border or header underline.</p>
      <p className="card-text">It looks simple and clean.</p>
    </Card>
  </div>
);

export default CardDemo;
